import React from "react";
import styles from "./styles/ContactLocation.module.css";
import companyImg from "../../../images/contact.jpg";

export default function ContactLocation() {
  return (
    <div className={styles.imageWrap}>
      <img
        src={companyImg}
        alt="Alliance Automation facility"
        className={styles.image}
        loading="lazy"
      />
    </div>
  );
}
